export default function About() {
  return (
    <section id="service" className="bg-background-100 pt-24 md:pt-32 pb-24 md:pb-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-3xl mx-auto reveal">
          <span className="font-heading italic text-primary-600 text-sm tracking-[0.3em] uppercase">
            About Anet paeking
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl lg:text-6xl leading-tight text-foreground-950">
            試合日に、<br />
            <span className="italic">ちいさなストレスも、</span><br />
            すべて置いていく。
          </h2>
          <p className="mt-5 text-foreground-700 text-sm md:text-base leading-relaxed">
            北広島市西の里。アネットパーキングはエスコンフィールド北海道への送迎に特化した完全予約制の駐車場です。試合日のみ営業、 スタジアムまでの無料シャトルで、混雑知らずの快適な観戦体験を提供します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-10 md:mt-14 lg:mt-20">
          <div className="bg-primary-500 rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10 relative overflow-hidden">
            <div className="flex items-start justify-between">
              <div className="font-heading text-background-50 text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-none">
                完全<span className="text-xl sm:text-2xl md:text-3xl ml-1 md:ml-2">予約制</span>
              </div>
              <a href="#reserve" className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50 text-primary-600 hover:bg-secondary-100 cursor-pointer transition-colors">
                <i className="ri-arrow-right-up-line text-lg" />
              </a>
            </div>
            <div className="mt-8 text-background-50">
              <div className="text-base md:text-lg font-medium">
                電話・LINE・SNSで簡単予約
              </div>
              <p className="mt-2 text-sm text-background-100 leading-relaxed">
                お電話または公式LINEから空き状況を確認して即予約。
                試合当日の飛び込み予約も、空きがあれば対応可能です。
                「サクッと予約して、あとは試合を楽しむだけ」。
              </p>
              <p className="mt-8 font-heading italic text-secondary-200 text-lg">
                "面倒な駐車場探しは、もう終わり。"
              </p>
            </div>
          </div>

          <div className="bg-accent-500 rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10 relative overflow-hidden">
            <div className="flex items-start justify-between">
              <div className="font-heading text-background-50 text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-none">
                無料<span className="text-xl sm:text-2xl md:text-3xl ml-1 md:ml-2">送迎</span>
              </div>
            </div>
            <div className="mt-8 text-background-50">
              <div className="text-base md:text-lg font-medium">
                往復無料シャトル運行
              </div>
              <p className="mt-2 text-sm text-background-100 leading-relaxed">
                駐車完了からエスコンフィールド北海道の
                ゲート前まで専用シャトルで送迎。
                試合開始前・終了後ともに運行、渋滞知らずで快適移動。
              </p>
              <p className="mt-8 font-heading italic text-secondary-100 text-lg">
                "歩かなくていい観戦体験を。"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}